import { render, staticRenderFns } from "./Assigment.modal.vue?vue&type=template&id=ed8d0f8c"
import script from "./Assigment.modal.vue?vue&type=script&lang=js"
export * from "./Assigment.modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports